import { isJson } from 'helper';
import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  deleteMaskName,
  getMaskNamesList,
  sendMessage,
  updateActiveMaskName,
  updateMaskName,
} from './actions';

export const useMaskNameList = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-mask-name-list', params],
    queryFn: getMaskNamesList,
    retry: false,
    keepPreviousData: true,
  });
  const temp = raw?.data?.data;
  const data = temp?.map((x) => ({
    ...x,
    form_upload_url: isJson(x?.form_upload_url)
      ? JSON.parse(x?.form_upload_url)
      : x?.form_upload_url,
  }));
  const meta = raw?.data?.meta;
  return [isLoading, data, meta];
};

export const useUpdateMaskName = ({ onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(updateMaskName, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-mask-name-list');
      queryClient.invalidateQueries('get-org-mask-name-list');
      toastSuccess('Successfully updated mask name!');
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export const useUpdateActiveMaskName = (cb) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(updateActiveMaskName, {
    onSuccess: (res) => {
      const response = res?.data?.data;
      const isDeactivate = response?.is_deactivate;
      const label = isDeactivate ? 'deactivated' : 'activated';
      queryClient.invalidateQueries('get-mask-name-list');
      toastSuccess(`Successfully ${label} mask name!`);
      if (typeof cb === 'function') cb();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof cb === 'function') cb();
    },
  });
  return [isLoading, mutate];
};

export const useDeleteMaskName = (cb) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(deleteMaskName, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-mask-name-list');
      toastSuccess('Successfully deleted mask name!');
      if (typeof cb === 'function') cb();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof cb === 'function') cb();
    },
  });
  return [isLoading, mutate];
};

export const useSendMessage = (cb) => {
  const { mutate, isLoading } = useMutation(sendMessage, {
    onSuccess: () => {
      toastSuccess('Successfully sent message!');
      if (typeof cb === 'function') cb();
    },
    onError: (err) => {
      toastError(
        err?.response?.data?.data?.message || 'Message failed to send!',
      );
      if (typeof cb === 'function') cb();
    },
  });
  return [isLoading, mutate];
};
